module.exports = __webpack_public_path__ + "static/eden-floor-plan-3d496eaaab82de28a123f0ef972f9d39.jpg";